import axios from "axios";
export default class PaymentService {
    loadPayments(orderId) {
        return axios.get('payment/all', {
            params: {
                orderId: orderId
            },
            withCredentials: true
        });
    }
    createOrUpdatePayment(payment) {
        return axios.post("/payment", payment, {
            withCredentials: true
        });
    }
    deletePayment(paymentId) {
        return axios.delete("/payment/" + paymentId, {
            withCredentials: true
        });
    }
}
